import React from "react";
import {
  Container,
  ImageWrapper,
  PreviewTitleText,
  TitleContainer,
  TitleText,
} from "./styles";

import ArrowLeft from "../../assets/icons/arrow-left.svg";
import CloseIcon from "../../assets/icons/close.svg";

interface SidebarCardHeaderProps {
  isBackAvailable?: boolean;
  onBackApply?: () => void;
  previewTitle: string;
  title?: string;
  onClose: () => void;
  color: string;
  lastUpdateInfo?: string;
  colorTitle?: string;
  isShowClose?: boolean;
}

const SidebarCardHeader: React.FC<SidebarCardHeaderProps> = ({
  isBackAvailable,
  onBackApply,
  previewTitle,
  title,
  onClose,
  color,
  lastUpdateInfo,
  colorTitle,
  isShowClose = true,
}) => {
  return (
    <Container>
      {isBackAvailable && (
        <ImageWrapper
          onClick={() => {
            if (onBackApply) {
              onBackApply();
            }
          }}
        >
          <img src={ArrowLeft} alt={"alt"} />
        </ImageWrapper>
      )}
      <TitleContainer>
        <PreviewTitleText>{previewTitle}</PreviewTitleText>
        {/* <TitleText color={lastUpdateInfo ? "#888" : colorTitle}>
          {title}
        </TitleText> */}
        {lastUpdateInfo && (
          <PreviewTitleText color={colorTitle}>
            Последнее обновление {lastUpdateInfo.replaceAll("-", ".")}
          </PreviewTitleText>
        )}
      </TitleContainer>
      {isShowClose && (
        <ImageWrapper onClick={onClose}>
          <img src={CloseIcon} alt={"alt"} />
        </ImageWrapper>
      )}
    </Container>
  );
};

export default SidebarCardHeader;
